module.exports = __webpack_public_path__ + "img/five-thirds-green.c3baa38e.png";